import React, { useContext } from 'react';
import { Organization } from 'constants/interface';

interface OrganizationContext {
  organization?: Organization
  update: (organization?: Organization) => void
}

export const OrganizationContext = React.createContext<OrganizationContext>({
  organization: undefined,
  update: () => {},
});

export const useOrganizationContext = (): OrganizationContext => {
  const context = useContext(OrganizationContext);

  return context;
};
